import React, { useState } from 'react';
import './Page.css';
import ContactModal from '../components/ContactModal';

const Services = () => {
  const [flippedCards, setFlippedCards] = useState({});
  const [selectedService, setSelectedService] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const services = [
    {
      id: 'septic-tank-pumping',
      title: 'Septic Tank Pumping',
      description: 'Regular pumping to maintain your septic system\'s efficiency and prevent costly repairs.',
      details: {
        title: 'Septic Tank Pumping Services',
        content: 'We provide professional septic tank pumping services for all types of systems including:',
        list: [
          'Residential septic tanks (500-1500 gallons)',
          'Commercial septic systems',
          'Large capacity tanks',
          'Conventional gravity systems',
          'Pressure distribution systems',
          'Aerobic treatment systems'
        ],
        additional: 'Our experienced team uses state-of-the-art equipment to safely and efficiently pump your septic tank, removing all solids and liquids while ensuring proper disposal.'
      }
    },
    {
      id: 'system-inspection',
      title: 'System Inspection',
      description: 'Thorough inspections to identify potential issues before they become major problems.',
      details: {
        title: 'Comprehensive System Inspections',
        content: 'Our detailed inspections cover all aspects of your septic system:',
        list: [
          'Tank condition and structural integrity',
          'Sludge and scum levels',
          'Drain field assessment',
          'Pump and component functionality',
          'System capacity evaluation',
          'Compliance with local regulations'
        ],
        additional: 'We provide detailed reports with recommendations to help you maintain your system and avoid costly repairs.'
      }
    },
    {
      id: 'emergency-service',
      title: 'Emergency Service',
      description: '24/7 emergency response for urgent septic system issues.',
      details: {
        title: '24/7 Emergency Septic Services',
        content: 'Available around the clock for urgent situations including:',
        list: [
          'Sewage backups',
          'Overflowing tanks',
          'System failures',
          'Drain field problems',
          'Pump malfunctions',
          'Blocked lines'
        ],
        additional: 'Our emergency response team is ready 24/7/365 to quickly address your septic emergencies and prevent further damage to your property.'
      }
    },
    {
      id: 'maintenance-programs',
      title: 'Maintenance Programs',
      description: 'Scheduled maintenance plans to keep your system running smoothly year-round.',
      details: {
        title: 'Preventive Maintenance Programs',
        content: 'Our maintenance programs include:',
        list: [
          'Regular scheduled pumping',
          'Quarterly inspections',
          'System monitoring',
          'Priority emergency service',
          'Maintenance reminders',
          'Detailed service records'
        ],
        additional: 'Protect your investment with our comprehensive maintenance programs designed to extend the life of your septic system and prevent unexpected issues.'
      }
    },
    {
      id: 'consultation',
      title: 'Consultation',
      description: 'Professional advice on septic system care and best practices.',
      details: {
        title: 'Expert Septic System Consultation',
        content: 'Get professional guidance on:',
        list: [
          'System design and planning',
          'Maintenance best practices',
          'Troubleshooting advice',
          'Upgrade recommendations',
          'Regulatory compliance',
          'Cost-effective solutions'
        ],
        additional: 'Our experienced consultants provide expert advice to help you make informed decisions about your septic system needs.'
      }
    }
  ];

  const handleCardClick = (serviceId) => {
    setFlippedCards(prev => ({
      ...prev,
      [serviceId]: !prev[serviceId]
    }));
  };

  const handleGetQuote = (service) => {
    setSelectedService(service);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedService(null);
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <div className="services-header-container">
          <img src="/AASP_Trunk_Left.jpg" alt="All Around Septic Pumping Truck" className="services-header-image left" />
          <div className="services-header-text">
            <h1>Our Services</h1>
            <p className="page-subtitle">Comprehensive septic system solutions</p>
          </div>
          <img src="/AASP_Trunk_Right.jpg" alt="All Around Septic Pumping Truck" className="services-header-image right" />
        </div>
      </div>

      <div className="content-section">
        <div className="services-grid">
          {services.map((service) => (
            <div
              key={service.id}
              className={`flip-card ${flippedCards[service.id] ? 'flipped' : ''}`}
              onClick={() => handleCardClick(service.id)}
            >
              <div className="flip-card-inner">
                <div className="flip-card-front">
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                  <div className="flip-hint">Click to learn more</div>
                </div>
                <div className="flip-card-back">
                  <h3>{service.details.title}</h3>
                  <p className="details-intro">{service.details.content}</p>
                  <ul className="details-list">
                    {service.details.list.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                  <p className="details-additional">{service.details.additional}</p>
                  <button
                    className="quote-button"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleGetQuote(service);
                    }}
                  >
                    Get a Quote
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {isModalOpen && (
        <ContactModal
          service={selectedService}
          onClose={closeModal}
        />
      )}
    </div>
  );
};

export default Services;

